export function getIconPrefix(icon: string) {
  return icon.startsWith("fa") ? "fab" : "mdi";
}
